(function (angular) {
    'use strict';

    angular.module("broadcastReports")
        .controller("ReportsBroadcastCtrl", [
            "$stateParams", "$scope", "$rootScope", 'broadcastSharedService', 'broadcastService', 'broadcastChannels', 'jwtService', 'NgTableParams', '$filter', 'sharedChartService',
            function ($stateParams, $scope, $rootScope, broadcastSharedService, broadcastService, broadcastChannels, jwtService, ngTableParams, $filter, sharedChartService) {

                $scope.broadcastsHistory = [];
                $scope.filters = {
                    name: undefined,
                    channelId: undefined
                }
                $scope.createdFrom = undefined;
                $scope.createdTo = undefined;

                $scope.onDateRangeChange = function (from, to) {
                    $scope.createdFrom = from;
                    $scope.createdTo = to;

                    $scope.refresh();
                };

                $scope.refresh = function () {
                    return broadcastService.getBroadcastsHistory($stateParams.pickedApiSpaceId,
                        $scope.createdFrom,
                        $scope.createdTo)
                        .then(function (result) {
                            $scope.broadcastsHistory = result;
                            $scope.broadcastsHistoryTable.reload();
                        }).catch(function (error) {
                            console.error("getBroadcastsHistory() failed", error);
                        });

                };
                $scope.getProfiles = function (broadcast) {
                    return (broadcast.totals && broadcast.totals.profiles) ? broadcast.totals.profiles : 0;
                }

                $scope.getSent = function (broadcast) {
                    return (broadcast.totals && broadcast.totals.sent) ? (broadcast.totals.sent[broadcast.broadcast.rules[0]] || 0) : 0;
                };

                $scope.getPercentSent = function (broadcast) {
                    return (Math.floor(($scope.getSent(broadcast) / ($scope.getProfiles(broadcast) || 1)) * 100));
                };

                $scope.getDelivered = function (broadcast) {
                    return (broadcast.totals && broadcast.totals.delivered) ? (broadcast.totals.delivered[broadcast.broadcast.rules[0]] || 0) : 0;
                };

                $scope.getPercentDelivered = function (broadcast) {
                    return (Math.floor(($scope.getDelivered(broadcast) / ($scope.getProfiles(broadcast) || 1)) * 100));
                }

                $scope.getExpired = function (broadcast) {
                    return (broadcast.totals && broadcast.totals.expired) ? (broadcast.totals.expired[broadcast.broadcast.rules[0]] || 0) : 0;
                };

                $scope.getPercentExpired = function (broadcast) {
                    return (Math.floor(($scope.getExpired(broadcast) / ($scope.getProfiles(broadcast) || 1)) * 100));
                }

                $scope.getFailed = function (broadcast) {
                    return broadcast.totals && broadcast.totals.failed ? broadcast.totals.failed : 0;
                }

                $scope.getPercentFailed = function (broadcast) {
                    return (Math.floor(($scope.getFailed(broadcast) / (($scope.getProfiles(broadcast)) || 1)) * 100));
                }

                $scope.getRead = function (broadcast) {
                    return broadcast.totals && broadcast.totals.read ? (broadcast.totals.read[broadcast.broadcast.rules[0]] || 0) : 0;
                }

                $scope.getPercentRead = function (broadcast) {
                    return (Math.floor(($scope.getRead(broadcast) / ($scope.getDelivered(broadcast) || 1)) * 100));
                }

                $scope.getBroadcastPopover = function (broadcast) {
                    if (broadcast.sendId) {
                        return '<b>Broadcast id:</b> ' + broadcast.broadcast.id + '<br><b>Send id:</b> ' + broadcast.sendId;
                    }
                    else {
                        return '<b>Broadcast id:</b> ' + broadcast.id;
                    }
                };
                var channels = broadcastChannels;
                $scope.channels = Object.keys(channels).filter((channelId) => {
                    return channels[channelId].allowed;
                }).map((channelName) => {
                    return {
                        id: channels[channelName].id,
                        label: channels[channelName].label
                    };
                });
                $scope.exportData = function (broadcastId, sendId) {

                    var url = "/apispaces/" + $stateParams.pickedApiSpaceId + "/broadcasts/" + broadcastId + "/history/" + sendId + "/export?includeHeaders=true&fieldSeparator=','";

                    $rootScope.$broadcast('fileDownload', { url: url, token: jwtService.token, fileName: "broadcastReport.csv", httpVerb: "GET", acceptHeaders: "application/csv" });
                };

                var storedChannelId = sharedChartService.initialiseWatch($scope, "filters.channelId", $stateParams.pickedApiSpaceId, "ReportsBroadcastCtrl");
                if (!$scope.channels.find((singleChannel) => storedChannelId === singleChannel.id)) {
                    storedChannelId = "";
                }
                $scope.filters.channelId = $stateParams.channelId || storedChannelId || ($scope.channels[0] ? $scope.channels[0].id : '');

                $scope.getUsername = broadcastSharedService.getUsername;
                $scope.viewDetails = broadcastSharedService.showBroadcastDetails;
                $scope.reuse = broadcastSharedService.duplicateBroadcast;

                $scope.broadcastsHistoryTable = new ngTableParams({
                    page: 1,            // show first page
                    count: 10,           // count per page
                    sorting: {
                        name: 'asc'     // initial sorting
                    },
                    filter: $scope.filters
                }, {
                    total: $scope.broadcastsHistory.length, // length of data
                    getData: function ($defer, params) {
                        // use build-in angular filter
                        var orderedData = params.sorting() ? $filter('orderBy')($scope.broadcastsHistory, params.orderBy()) : $scope.broadcastsHistory;
                        var filter = params.filter();
                        orderedData = $filter('filter')(orderedData, function (value) {
                            return (!filter.name || value.broadcast.name.includes(filter.name)) && value.broadcast.rules[0].includes(filter.channelId);
                        });
                        $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                        params.total(orderedData.length);
                    },
                    filterDelay: 100
                });

            }
        ]);

})(window.angular);

